module.exports = __webpack_public_path__ + "static/media/UG.6368fa8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/UG.svg
// module id = 2284
// module chunks = 7